// tslint:disable-next-line:max-line-length
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { SiteService, CommonService, LoadService } from 'src/app/services/index';
import { FormGroupDirective, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Constants, AlertService, API_BASE$, FabricService, ActionModeEnum } from 'src/app/shared';
import { Attachment, NodeDetailModel, FabricModel } from 'src/app/models/index';
import * as ObjectUtils from 'util';
import * as cloneDeep from 'lodash/cloneDeep';
import { fabric, Canvas } from 'fabric';
// import { Canvas, StaticCanvas } from 'fabric/fabric-impl';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { NodeDetailComponent } from 'src/app/Components/add/add-node/node-detail/node-detail.component';

@Component({
  selector: 'app-add-node',
  templateUrl: './add-node.component.html',
  styleUrls: ['./add-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNodeComponent implements OnInit, AfterViewChecked, AfterViewInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  @ViewChild('loadImgCanvas', { read: ElementRef }) canvasRef: ElementRef;
  formMasterGroup: FormGroup;
  sites: any;
  load: any;
  loadTypes = [];
  loadSubTypes = [];
  subTypes = {};
  consLoadTypeObj = Constants.LOAD_TYPE;
  consLoadTypeKeys = Object.keys(this.consLoadTypeObj);
  loadDetails = [];
  loadAttachment: Attachment = new Attachment();
  loadImgFileContents = '';
  rowsAndColumns: any;
  requiredValidators = [Validators.required];
  canvas: Canvas;
  canvasGroup: fabric.Group;
  currentMousePosition: any;
  nodeDetail: NodeDetailModel;
  originalNodeDetail: NodeDetailModel;
  inputSensors: any;
  outputSensors: any;
  imageBinary = '';
  canvasOriginalWidth: number;
  canvasOriginalHeight = 650;
  canvasWidth: number;
  canvasHeight = 650;
  imgWidth: number;
  imgHeight: 650;
  canvasScaleX = 1;
  canvasScaleY = 1;
  isViewInit = false;
  constructor(private siteService: SiteService,
    private loadService: LoadService,
    private alertService: AlertService,
    private commonService: CommonService,
    private fabricService: FabricService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    public dialog: MatDialog) {
    this.load = {};
    this.currentMousePosition = {};
    this.rowsAndColumns = null;
    this.formMasterGroup = this.fb.group({
      siteNameCtr: ['', [Validators.required]],
      loadTypeCtr: ['', [Validators.required]],
      subTypeCtr: [''],
      loadCtr: ['', [Validators.required]],
      noRowAndColumnCtr: [''],
      uploadLoadImageCtr: ['']
    });
    this.siteService.getAllSites().subscribe(data => {
      this.sites = data;
    });
    for (let i = 0; i < this.consLoadTypeKeys.length; i++) {
      const temp = this.consLoadTypeObj[this.consLoadTypeKeys[i]]['TYPE_VALUE'];
      if (temp === 'GenericSensorLoad') {
        this.loadTypes.push('Generic / Area Specific Sensor');
      } else {
        this.loadTypes.push(temp);
      }
    }
    this.inputSensors = [];
    this.outputSensors = [];
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
    window.addEventListener('resize', this.resizeCanvas);
    //  Check later, Need bind event on group after load from Json
    // this.canvas = new fabric.Canvas('loadImgCanvasTest', {hoverCursor: 'pointer',
    // selection: false,
    // selectionBorderColor: 'green',
    // backgroundColor: null});
    // this.canvas.setWidth(800);
    // this.canvas.setHeight(800);
    // this.canvas.on('mouse:dblclick', this.onImageClick);
    // // tslint:disable-next-line:max-line-length
    // const json = '{"version":"3.4.0","objects":[{"type":"group","version":"3.4.0","originX":"left","originY":"top","left":217,"top":84.8,"width":66,"height":26,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"objects":[{"type":"rect","version":"3.4.0","originX":"left","originY":"top","left":-33,"top":-13,"width":65,"height":25,"fill":"#F9D124","stroke":"blue","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"text","version":"3.4.0","originX":"left","originY":"top","left":-30,"top":-8,"width":20.96,"height":13.56,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"abc","fontSize":12,"fontWeight":"bold","fontFamily":"Bosch-Sans","fontStyle":"normal","lineHeight":1.16,"underline":false,"overline":false,"linethrough":false,"textAlign":"left","textBackgroundColor":"","charSpacing":0,"styles":{}}]},{"type":"group","version":"3.4.0","originX":"left","originY":"top","left":391,"top":157.8,"width":66,"height":26,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"objects":[{"type":"rect","version":"3.4.0","originX":"left","originY":"top","left":-33,"top":-13,"width":65,"height":25,"fill":"#F9D124","stroke":"blue","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"text","version":"3.4.0","originX":"left","originY":"top","left":-30,"top":-8,"width":19.9,"height":13.56,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"xyz","fontSize":12,"fontWeight":"bold","fontFamily":"Bosch-Sans","fontStyle":"normal","lineHeight":1.16,"underline":false,"overline":false,"linethrough":false,"textAlign":"left","textBackgroundColor":"","charSpacing":0,"styles":{}}]},{"type":"group","version":"3.4.0","originX":"left","originY":"top","left":646,"top":187.8,"width":66,"height":26,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"objects":[{"type":"rect","version":"3.4.0","originX":"left","originY":"top","left":-33,"top":-13,"width":65,"height":25,"fill":"#F9D124","stroke":"blue","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"text","version":"3.4.0","originX":"left","originY":"top","left":-30,"top":-8,"width":20.25,"height":13.56,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"aaa","fontSize":12,"fontWeight":"bold","fontFamily":"Bosch-Sans","fontStyle":"normal","lineHeight":1.16,"underline":false,"overline":false,"linethrough":false,"textAlign":"left","textBackgroundColor":"","charSpacing":0,"styles":{}}]}],"backgroundImage":{"type":"image","version":"3.4.0","originX":"left","originY":"top","left":0,"top":0,"width":850,"height":650,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","cropX":0,"cropY":0,"src":"http://localhost:4200/iep/energyService/v1/site/image/Load/360:74","filters":[]}}';
    // // tslint:disable-next-line:max-line-length
    // this.canvas.loadFromJSON(json, (image: any) => {
    //   this.canvas.renderAll();
    //   this.canvas.forEachObject((obj: fabric.Object) => {
    //     if (obj.type === 'group') {
    //       const group = <fabric.Group>obj;
    //       group.selectable = false;
    //       group.subTargetCheck = true;
    //       group.on('mousedown', this.onEditNodeDetail);
    //     }
    //   });
    //   this.canvas.renderAll();
    // });
  }
  ngOnInit() {
    // this.initLoadImageCanvas('./assets/img/ATMO_Img.png');
    // tslint:disable-next-line:max-line-length
    // subscribe from dialog to add node on image
    this.commonService.getNodeDetailSubject().subscribe(data => {
      // create text
      const option = this.getFabricOptionBasedOnMouseClick();
      this.bindNodeDetail(true, data, option);
      const text = this.fabricService.fabricTextInRect(this.nodeDetail);
      option.width = text.width + 10;
      option.height = text.height + 5;
      const rect = this.fabricService.fabricRect(this.nodeDetail);
      // add Rect and text to a group
      // It is possible to listen for events on the inner object by adding the option: subTargetCheck: true to the fabric
      const group = new fabric.Group([rect, text],
        { selectable: true, subTargetCheck: true }
      );
      // detect Editing, Adding, or Delete mode
      switch (data.actionMode) {
        case ActionModeEnum.Creating: {
          this.canvas.add(group);
          this.canvas.renderAll();
          break;
        }
        case ActionModeEnum.Editing:
        case ActionModeEnum.Deleting: {
          const objects = this.canvas.getObjects();
          for (let i = 0; i < objects.length; i++) {
            const obj = <any>objects[i];
            if ((Array.from(obj._objects)).filter((x: any) => x.nodeName === this.originalNodeDetail.nodeName).length > 0) {
              this.canvas.remove(obj);
              this.canvas.renderAll();
              break;
            }
          }
          if (data.actionMode === ActionModeEnum.Editing) {
            this.canvas.add(group);
            this.canvas.renderAll();
          }
          break;
        }
        default: {
          break;
        }
      }
      // reset actionMode
      this.nodeDetail.actionMode = ActionModeEnum.Creating;
      // group.on('mouse:down', this.onEditNodeDetail);
      // this.canvasGroup.addWithUpdate(group);
      // this.canvas.add(group);
      // mousedown mouse:down' => not working
      group.on('mousedown', this.onEditNodeDetail);

      // const objectsTested = this.canvas.getObjects();
      //   for (let i = 0; i < objectsTested.length; i++) {
      //     const obj = <any>objectsTested[i];
      //     Array.from(obj._objects).forEach((element: fabric.Object) => {
      //       element.on('mousedown', this.onEditNodeDetail);
      //     });
      //   }
    });
  }
  private bindNodeDetail = (isEditing: boolean, data?: any, option?: any) => {
    const newLoad = this.cloneDeepLoad();
    if (isEditing) {
      this.nodeDetail = new NodeDetailModel(
        null, data.nodeName, option,
        this.inputSensors, this.outputSensors, data.selectedInputSensors,
        data.selectedOutputSensors,
        data.inputSensorCriteria, data.outputSensorCriteria, newLoad, ActionModeEnum.Editing);
    } else {
      this.nodeDetail = new NodeDetailModel(
        null, null, null,
        this.inputSensors, this.outputSensors, null,
        null,
        null, null, newLoad, ActionModeEnum.Creating);
    }
  }
  //   private resizeCanvas = () => {
  //     // Wait resize completed
  //     setTimeout(() => {
  //       if (this.canvas) {
  //         this.setCanvasSize();
  //         const objects = this.canvas.getObjects();
  //         for (let i = 0; i < objects.length; i++) {
  //          const scaleX = objects[i].scaleX;
  //          const scaleY = objects[i].scaleY;
  //          const left = objects[i].left;
  //          const top = objects[i].top;
  //          const tempScaleX = scaleX * this.canvasScaleX;
  //          // const tempScaleY = scaleY * this.canvasScaleY;
  //         //  const tempLeft =  this.canvasScaleLeft < 0 ? Math.abs(this.canvasScaleLeft) - left : Math.abs(this.canvasScaleLeft) + left;
  //         const tempLeft =  left * this.canvasScaleX;
  //          const tempTop = top * this.canvasScaleY;
  //         objects[i].scaleX = tempScaleX;
  //          // objects[i].scaleY = tempScaleY;
  //          objects[i].left = tempLeft;
  //          objects[i].top = tempTop;
  //          objects[i].setCoords();
  //         }
  //         this.canvas.renderAll();
  //        this.canvas.calcOffset();
  //        }
  //     }, 700);
  //  }
  private resizeCanvas = () => {
    setTimeout(() => {
      if (this.canvas !== undefined && this.canvas.backgroundImage) {
        this.setCanvasSize(true);
        const bi = <fabric.Image>this.canvas.backgroundImage;
        const options = this.getImageOptions(bi);
        // bi.left = options.left;
        // bi.top = options.top;
        bi.scaleX = options.scaleX;
        bi.scaleY = options.scaleY;
        const objects = this.canvas.getObjects();
        for (let i = 0; i < objects.length; i++) {
          const scaleX = objects[i].scaleX;
          const scaleY = objects[i].scaleY;
          const left = objects[i].left;
          const top = objects[i].top;
          const tempScaleX = scaleX * this.canvasScaleX;
          const tempScaleY = scaleY * this.canvasScaleY;
          const tempLeft = left * this.canvasScaleX;
          const tempTop = top * this.canvasScaleY;
          objects[i].scaleX = tempScaleX;
          objects[i].scaleY = tempScaleY;
          objects[i].left = tempLeft;
          objects[i].top = tempTop;
          objects[i].setCoords();
        }
        this.canvas.renderAll();
        this.canvas.calcOffset();
      }
    }, 700);

  }
  // private initCanvas = () => {
  //   this.canvas = new fabric.Canvas('loadImgCanvas', {hoverCursor: 'pointer',
  //   selection: false,
  //   backgroundColor: null});
  //   this.setCanvasSize();
  //   this.canvas.on('mouse:dblclick', this.onImageClick);
  //   this.canvas.renderAll();
  // }
  private initLoadImageCanvas = (fileContent: string) => {
    this.canvas = new fabric.Canvas('loadImgCanvas', {
      hoverCursor: 'pointer',
      selection: false,
      selectionBorderColor: 'green',
      backgroundColor: null
    });
    this.setCanvasSize();
    const canvasSelf = this.canvas;
    const self = this;
    const ctx = this.canvas.getContext();
    const imgObj = new Image();
    imgObj.src = `data:image/jpeg;base64,${fileContent}`;
    imgObj.onload = function () {
      ctx.drawImage(imgObj, 0, 0);
      const image = new fabric.Image(imgObj);
      const options = self.getImageOptions(image);
      canvasSelf.setBackgroundImage(image, canvasSelf.renderAll.bind(canvasSelf), options);
      canvasSelf.on('mouse:dblclick', self.onImageClick);
      canvasSelf.renderAll();
    };
    // fabric.Image.fromElement(image, (img) => {});
    // this.canvas.setBackgroundImage(image, this.canvas.renderAll.bind(this.canvas), {});
    // ctx.drawImage(image, 0, 0);
    // this.canvas.setBackgroundImage(url, this.canvas.renderAll.bind(this.canvas), {});
    // fabric.Image.fr
    // load image
    // fabric.Image.fromURL('./assets/img/ATMO_Img.png', (img) => {
    //   // img.scaleToWidth(750);
    //   // img.scaleToHeight(750);
    //   // add image and text to a group
    //   this.canvasGroup = new fabric.Group([img], {subTargetCheck: true});
    //   this.canvas.add(this.canvasGroup);
    // });
    // this.canvas.on('mouse:dblclick', this.onImageClick);
  }
  private getImageOptions = (image: fabric.Image) => {
    const self = this;
    // image.scaleX = canvasSelf.getWidth() / image.width;
    // image.scaleY = canvasSelf.getHeight() / image.height;
    // Get image size from uploading after draw
    const canvasAspect = self.canvasWidth / self.canvasHeight;
    const imgAspect = image.width / image.height;
    let scaleX = 0;
    let scaleY = 0;
    // let scaleFactor: number;
    if (canvasAspect >= imgAspect) {
      // scaleX = self.canvasWidth / image.width;
      scaleX = 1;
      scaleY = 1;
      // this.canvasScale = 1;
      //  left = 0;
      //  top = -((image.height * scaleFactor) - self.canvasHeight) / 2;
    } else {
      scaleX = self.canvasWidth / image.width;
      scaleY = self.canvasHeight / image.height;
      // left = -((image.width * scaleFactor) - self.canvasWidth) / 2;
    }
    return { top: 0, left: 0, originX: 'left', originY: 'top', scaleX: scaleX, scaleY: scaleY };
  }
  private setCanvasSize = (isResized: boolean = false) => {
    const temp = document.querySelector('#wrapper');
    if (temp) {
      const bcr = temp.getBoundingClientRect();
      this.canvasWidth = bcr.right - bcr.left;
      if (isResized && this.canvasOriginalWidth !== undefined) {
        this.canvasScaleX = this.canvasWidth / this.canvasOriginalWidth;
      }
      this.canvasOriginalWidth = cloneDeep(this.canvasWidth);
      this.canvas.setWidth(this.canvasWidth);
      this.canvas.setHeight(this.canvasHeight);
    }
  }
  private getFabricOptionBasedOnMouseClick = () => {
    return new FabricModel(this.currentMousePosition.x, this.currentMousePosition.y);
  }
  private onImageClick = (e: any) => {
    this.currentMousePosition = this.fabricService.getMousePosition('loadImgCanvas', e.e.clientX, e.e.clientY);
    this.bindNodeDetail(false, null, null);
    this.onShowDialogNodeDetail(this.nodeDetail);
  }
  private onEditNodeDetail = (e: any) => {
    // e.target._objects[0]
    this.currentMousePosition = this.fabricService.getMousePosition('loadImgCanvas', e.e.clientX, e.e.clientY);
    const currentNode = e.subTargets[0];
    const nodeDetail: NodeDetailModel = new NodeDetailModel();
    Object.assign(nodeDetail, currentNode);
    nodeDetail.inputSensors = this.inputSensors;
    nodeDetail.outputSensors = this.outputSensors;
    nodeDetail.actionMode = ActionModeEnum.Editing;
    this.originalNodeDetail = cloneDeep(nodeDetail);
    if (nodeDetail !== undefined && nodeDetail.nodeName !== undefined) {
      this.onShowDialogNodeDetail(nodeDetail);
    }
  }
  private onShowDialogNodeDetail = (nodeDetail: NodeDetailModel = null) => {

    const dialogConfig: MatDialogConfig = { width: '90%', data: nodeDetail };
    this.dialog.open(NodeDetailComponent, dialogConfig);
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formMasterGroup.get(fieldName).hasError(errorCode);
  }
  public changeLoadType = () => {
    const cloneLoad = this.cloneDeepLoad();
    if (!ObjectUtils.isNullOrUndefined(cloneLoad.siteID)) {
      this.removeValidatorCtr();
      // this.removeNoRowValidatorCtr();
      this.removeUploadLoadImageCtr();
      // this.removeMeterCtr();
      const subTypeCtr = this.formMasterGroup.get('subTypeCtr');
      subTypeCtr.setValue(null);
      if (cloneLoad.type === 'Transformer' || cloneLoad.type === 'GenericSensorLoad') {
        this.getLoadsforSelectedloadType();
        subTypeCtr.setValidators(null);
        subTypeCtr.updateValueAndValidity();
      } else {
        subTypeCtr.setValidators(this.requiredValidators);
        subTypeCtr.updateValueAndValidity();
        if (this.subTypes[this.load.type] === undefined) {
          if (this.load.type !== undefined) {
            this.siteService.getLoadSubType(cloneLoad.type).subscribe(data => {
              const subTypesData = [];
              const loadTypeKey = this.getLoadTypeKeyByValue(data.type);
              if (loadTypeKey === undefined) {
                for (let i = 0; i < data.length; i++) {
                  subTypesData.push({ 'text': data[i], 'value': data[i] });
                }
              } else {
                const subTypesValueText = this.consLoadTypeObj[loadTypeKey]['SUB_TYPES_VALUE_TEXT'];
                if (subTypesValueText === undefined) {
                  for (let i = 0; i < data.length; i++) {
                    subTypesData.push({ 'text': data[i], 'value': data[i] });
                  }
                } else {
                  for (let i = 0; i < data.length; i++) {
                    const text = subTypesValueText[data[i]];
                    if (text !== undefined) {
                      subTypesData.push({ 'text': text, 'value': data[i] });
                    } else {
                      subTypesData.push({ 'text': data[i], 'value': data[i] });
                    }
                  }
                }
              }
              this.loadSubTypes = subTypesData;
              this.subTypes[this.load.type] = subTypesData;
            });
          }
        } else {
          this.loadSubTypes = this.subTypes[this.load.type];
        }
      }
    }
  }
  private getLoadsforSelectedloadType = () => {
    const newLoad = this.cloneDeepLoad();
    this.siteService.getLoadsBasedOnTypeAndSubType(newLoad).subscribe(data => {
      this.loadDetails = data;
    });
  }
  private getLoadTypeKeyByValue = (value: any) => {
    for (let i = 0; i < this.consLoadTypeKeys.length; i++) {
      if (this.consLoadTypeObj[this.consLoadTypeKeys[i]]['TYPE_VALUE'] === value) {
        return this.consLoadTypeKeys[i];
      }
    }
    return undefined;
  }
  private removeValidatorCtr = () => {
    const subTypeCtr = this.formMasterGroup.get('subTypeCtr');
    subTypeCtr.setValue(null);
    subTypeCtr.setValidators(null);
    subTypeCtr.updateValueAndValidity();
  }
  private removeUploadLoadImageCtr = () => {
    this.loadAttachment = new Attachment();
    const uploadLoadImageCtr = this.formMasterGroup.get('uploadLoadImageCtr');
    uploadLoadImageCtr.setValue(null);
    uploadLoadImageCtr.setValidators(null);
    uploadLoadImageCtr.updateValueAndValidity();
    this.canvas = null;
  }
  private removeNoRowValidatorCtr = () => {
    const noRowAndColumnCtr = this.formMasterGroup.get('noRowAndColumnCtr');
    noRowAndColumnCtr.setValue(null);
    noRowAndColumnCtr.setValidators(null);
    noRowAndColumnCtr.updateValueAndValidity();
  }
  private cloneDeepLoad = () => {
    const newLoad = cloneDeep(this.load);
    if (ObjectUtils.isNullOrUndefined(newLoad.siteID) === false) {
      newLoad.siteID = newLoad.siteID[0];
    }
    if (newLoad.type === 'Generic / Area Specific Sensor') {
      newLoad.type = 'GenericSensorLoad';
    }
    return newLoad;
  }
  public changeSubLoadType = () => {
    // this.removeNoRowValidatorCtr();
    this.removeUploadLoadImageCtr();
    const cloneLoad = this.cloneDeepLoad();
    if (cloneLoad.subType === 'Hydraulic Unit' || cloneLoad.subType === 'Generic Load') {
      // testing
      const uploadLoadImageCtr = this.formMasterGroup.get('uploadLoadImageCtr');
      // const inOutValidator = [Validators.required, Validators.min(1), Validators.max(12)];
      uploadLoadImageCtr.setValidators(this.requiredValidators);
      uploadLoadImageCtr.updateValueAndValidity();
    }
    // reset value for load
    const loadCtr = this.formMasterGroup.get('loadCtr');
    // const inOutValidator = [Validators.required, Validators.min(1), Validators.max(12)];
    loadCtr.setValue(null);
    loadCtr.updateValueAndValidity();
    this.getLoadsforSelectedloadType();
  }

  public changeLoad = () => {
    const cloneLoad = this.cloneDeepLoad();
    if (!ObjectUtils.isNullOrUndefined(cloneLoad.siteID)) {
      this.siteService.getSensorDetailsBasedOnLoadRId(cloneLoad).subscribe(data => {
        this.inputSensors = data.Inlets.map((item: any) => {
          return { 'sensorName': item.name, 'sensorRId': item.sensor.sensorRId };
        });
        this.outputSensors = data.Outlets.map((item: any) => {
          return { 'sensorName': item.name, 'sensorRId': item.sensor.sensorRId };
        });
      });
    }

  }
  public getBackgroundImage = () => {
    return `url('${this.loadImgFileContents}')`;
  }
  public uploadDocument = (event: any, pictType: string) => {
    if (event.target.files.length <= 0) {
      return;
    }
    const files = event.target.files;
    if (!this.commonService.isImageFile(files[0])) {
      this.commonService.showDialogMessage('File type not supported!');
      return;
    }
    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('documentType', pictType);
    this.siteService.uploadDocument(formData, pictType, 'comment', this.load.siteID).subscribe(data => {
      if (data === '' || this.commonService.isNullOrUndefined(data)) {
        this.alertService.showError('Upload file fail!');
        return;
      }
      if (data.documentType === Constants.DOCUMENT_TYPE.LOAD) {
        this.loadAttachment = data;
        // this.loadImgFileContents = `${API_BASE$}/${data.renderUrl}`;
        this.loadImgFileContents = `data:image/jpeg;base64, ${data.fileContent}`;
        this.initLoadImageCanvas(data.fileContent);
        // this.initCanvas();
      }
    });
  }
  public selectDocument = (elmId: string) => {
    const element: HTMLElement = document.getElementById(elmId) as HTMLElement;
    element.click();
  }
  public submit = () => {
    const cloneLoad = this.cloneDeepLoad();
    let htmlDivWithLabels = '';
    let params = {};
    if ((cloneLoad.subType === 'Hydraulic Unit' || cloneLoad.subType === 'Generic Load')
      && ObjectUtils.isObject(this.canvas) && !ObjectUtils.isNullOrUndefined(this.canvas)) {
      htmlDivWithLabels = JSON.stringify(this.canvas.toJSON());
      params = {
        'loadRId': cloneLoad.rId,
        'loadImgRId': this.loadAttachment.id,
        'htmlDivWithLabels': htmlDivWithLabels,
        'Type': cloneLoad.subType,
        'divClassName': 'splitImg'
      };
    } else {
      params = {
        'loadRId': cloneLoad.rId,
        'htmlDivWithLabels': '',
        'Type': cloneLoad.subType,
        'divClassName': 'splitImg'
      };
    }
    this.loadService.saveNodeDetailForLoad(params).subscribe(data => {
      if (data !== null) {
        this.alertService.message = 'Load with Node details added Successfully..!!';
        this.alertService.showSuccess();
        this.formDirective.resetForm();
        this.formMasterGroup.reset();
      } else {
        this.alertService.message = 'Failed to add Load with Node details..!!';
        this.alertService.showError();
      }
    });
  }
  public invalidControl = (event: any) => {
    event.preventDefault();
    const invalid = [];
    const controls = this.formMasterGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log('Invalid Conteol ---' + invalid);
  }
}
